import React from 'react';

const NotFound = () => <div>Wooops... nothing found here...</div>

export default NotFound;